<template>
  <div
    class="side-bar__section"
    :class="{ 'side-bar__section--shrunk': !isShrunk }"
  >
    <div
      v-if="!isShrunk && section.title"
      class="side-bar__section-header"
      :class="{ 'side-bar__section-header--close': section.isOpen }"
      @click="$emit('toggle', section.key)"
    >
      <div class="side-bar__section-header-text">
        {{ section.title }}
      </div>

      <div class="side-bar__section-header-icon">
        <gl-icon
          height="24"
          name="I-ChevronDown"
          width="24"
        />
      </div>
    </div>

    <div
      v-show="isShrunk || section.isOpen"
      class="side-bar__section-links"
    >
      <SidebarMenuItem
        v-for="link in section.links"
        :key="link.key"
        :has-notify="hasNotify"
        :is-mobile="isMobile"
        :is-shrunk="isShrunk"
        :is-tablet="isTablet"
        :link="link"
      />
    </div>
  </div>
</template>

<script>
import GlIcon from '@/components/gl-icon'
import SidebarMenuItem from '@/components/sidePanelMenu/SidebarMenuItem'

export default {
  name: 'SidebarSection',

  components: {
    GlIcon,
    SidebarMenuItem,
  },

  props: {
    section: {
      type: Object,
      required: true,
    },
    isShrunk: {
      type: Boolean,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    isTablet: {
      type: Boolean,
      required: true,
    },
    hasNotify: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style scoped>
.side-bar__section {
  padding: 8px 8px 0 8px;
  user-select: none;
}
.side-bar__section + .side-bar__section {
  border-top: 1px solid var(--Basic-200)
}
.side-bar__section + .side-bar__section--shrunk.side-bar__section {
  border-top: none;
}
.side-bar__section-header {
  display: flex;
  align-items: center;
  height: 32px;
  padding-left: 8px;
  font-weight: 600;
  font-size: var(--Size-XS);
  line-height: var(--Line-Height-XS);
  letter-spacing: var(--Letter-Spacing-None);
  color: var(--Basic-700) !important;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
}
.side-bar__section-header:before {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: var(--Corner-radius-M);
  background-color: transparent;
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  transition: background-color 0.3s ease;
}
.side-bar__section-header:hover:before {
  background-color: var(--Basic-100);
}
.side-bar__section-header-text {
  flex: 1 1 auto;
}
.side-bar__section-header-icon {
  flex: 0 0 24px;
  margin-right: 2px;
  transition: transform 0.3s ease;
}
.side-bar__section-header-icon svg {
  display: block;
}
.side-bar__section-header--close .side-bar__section-header-icon {
  transform: rotate(180deg);
}

@media (max-width: 767px) {
  .side-bar__section-header:before {
    display: none;
  }
}
</style>